// extracted by mini-css-extract-plugin
module.exports = {"icon":"expandingArrow_icon__vF1pF","right":"expandingArrow_right__ejU2I","left":"expandingArrow_left__Uu7YD","diagonal":"expandingArrow_diagonal__qy2Tt"};